import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog';

interface ConfirmModalProps {
  isOpen: boolean;
  isSyncEnabled: boolean;
  onToggle: () => void;
  onConfirm: () => void;
}

export function ConfirmModal({
  isOpen,
  isSyncEnabled,
  onToggle,
  onConfirm,
}: ConfirmModalProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.SeoContent.components.IntegrationForm.confirmModal',
  });

  return (
    <Dialog open={isOpen} onOpenChange={onToggle}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('title')}</DialogTitle>

          <DialogDescription>
            {isSyncEnabled ? (
              <Trans
                t={t}
                i18nKey="description.disable"
                components={{ strong: <strong /> }}
              />
            ) : (
              <Trans
                t={t}
                i18nKey="description.enable"
                components={{ strong: <strong /> }}
              />
            )}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button variant="outline" onClick={onToggle}>
            {t('cancelButton')}
          </Button>

          <Button onClick={onConfirm}>
            {isSyncEnabled
              ? t('confirmButton.disable')
              : t('confirmButton.enable')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
